import { render } from "./MainMenuView.vue?vue&type=template&id=2a2bc45e"
import script from "./MainMenuView.vue?vue&type=script&lang=js"
export * from "./MainMenuView.vue?vue&type=script&lang=js"

import exportComponent from "/home/websites/repositories/macgear-scanner/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__